module.exports = __webpack_public_path__ + "static/media/03_integrals_of_acceleration.9157fa5b.png";